import React from "react";

function Contact() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-4xl font-bold mb-4">Contact</h1>
      <p className="text-center max-w-2xl">
        If you have any questions or feedback, please contact us at support@iwastthere.com.
      </p>
    </div>
  );
}

export default Contact;